// component
import SvgColor from '../../../components/svg-color';


// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;


// const usuario = JSON.parse(localStorage.getItem('userData'))

const navConfig = [
  {
    title: 'Dashboard',
    path: '/agencia/inicio',
    icon: icon('ic_analytics'),
    supervisor: true
  }

].filter(Boolean);

export default navConfig;
